import React from 'react';
import { clients } from '../../data/mock';

const ClientsSection = () => {
  return (
    <section className="bg-white py-6 border-y border-gray-100">
      <div className="container-main">
        <div className="flex items-center gap-8 overflow-x-auto">
          <span className="text-sm font-medium text-navy whitespace-nowrap">Our Client</span>
          <div className="flex items-center gap-12 md:gap-16">
            {clients.map((client, index) => (
              <span
                key={client.id}
                className={`text-lg font-bold whitespace-nowrap ${
                  index === 0 ? 'text-navy' : 'text-gray-400'
                }`}
              >
                {index === 0 ? '☆' : ''} {client.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
